module.exports = __webpack_public_path__ + "static/media/logo.f2c8c8dd.png";